import React, { useEffect } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'

import ChangePassword from 'account/changePassword'
import { LOGIN_PATH } from 'account/login/Login'
import HSAStatus from 'employeeDashboard/common/hsaStatus'

import { Permissions } from 'core/application/account/permissions'

import useLoginUser from 'common/hooks/useLoginUser'

import { ROUTE_PATHS } from 'common/routePaths'

import NotFound from 'errorPages/NotFound'

import EmployeeDashboardWrapper, { MenuItem } from '../common/EmployeeDashboardWrapper'
import EditReimbursement from '../common/editReimbursement'
import MyProfile from '../common/employeeProfile'
import GetReimbursed from '../common/getReimbursed'
import LegalDocuments, { LEGAL_DOCUMENTS_PATH } from '../common/legalDocuments'
import TaxSavings from '../common/taxSavings'
import QseHraEEDashboardHome from './home'

type QseHraEligibleEmployeeDashboardProps = {}

const QseHraEligibleEmployeeDashboard: React.FC<QseHraEligibleEmployeeDashboardProps> = () => {
  const history = useHistory()
  const [user] = useLoginUser()

  useEffect(() => {
    if (!user.permissions.includes(Permissions.AccessEligibleEmployeeDashboard)) history.push(LOGIN_PATH)
  }, [])

  return (
    <EmployeeDashboardWrapper navigationMenu={navigationMenu}>
      <Switch>
        <Route
          key={NavigationMapping.MyProfile}
          path={`${ROUTE_PATHS.ELIGIBLE_EMPLOYEE_PROFILE}`}
          component={MyProfile}
        />
        <Route
          key={NavigationMapping.ChangePassword}
          path={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_CHANGE_PASSWORD}
          component={ChangePassword}
        />
        <Route
          key={NavigationMapping.GetReimbursed}
          path={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_GET_REIMBURSED}
          component={GetReimbursed}
        />
        <Route
          key={NavigationMapping.TaxSavings}
          path={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_TAX_SAVINGS}
          component={TaxSavings}
        />
        <Route
          key={NavigationMapping.HSAStatus}
          path={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_HSA_STATUS}
          component={HSAStatus}
        />
        <Route
          key={NavigationMapping.UpdatePremiumExpense}
          path={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_EDIT_PREMIUM_EXPENSE}
          component={EditReimbursement}
        />
        {navigationMenu
          .sort((first, second) => second.key - first.key)
          .map((item: MenuItem) => (
            <Route key={item.key} path={item.path} component={item.component} />
          ))}
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </EmployeeDashboardWrapper>
  )
}

enum NavigationMapping {
  Dashboard = 1,
  LegalDocuments = 2,
  MyProfile = 3,
  ChangePassword = 4,
  GetReimbursed = 5,
  UpdatePremiumExpense = 6,
  TaxSavings = 7,
  HSAStatus = 8,
}

const navigationMenu: MenuItem[] = [
  {
    name: 'menu.dashboard',
    key: NavigationMapping.Dashboard,
    path: ROUTE_PATHS.ELIGIBLE_EMPLOYEE_DASHBOARD,
    icon: 'dashboard',
    component: QseHraEEDashboardHome,
  },
  {
    name: 'menu.legal-documents',
    key: NavigationMapping.LegalDocuments,
    path: `${ROUTE_PATHS.ELIGIBLE_EMPLOYEE_DASHBOARD}/${LEGAL_DOCUMENTS_PATH}`,
    icon: 'file-protect',
    component: LegalDocuments,
  },
]

export default QseHraEligibleEmployeeDashboard
